<script setup lang="ts">
/**
 * « Découvrir aussi » des pages produit en charte « apple » (/cagnotte,
 * /billetterie…, Karim 2026-10-18) : chapitre gris, tuiles blanches avec
 * une icône sobre. Maillage interne entre les pages produit.
 */
import { TITRE_CARTE_APPLE, TITRE_SECTION_APPLE } from "~/utils/titresApple";

export interface PageLiee {
  title: string;
  description: string;
  href: string;
  icon: string;
}

defineProps<{
  titre: string;
  sousTitre?: string;
  pages: PageLiee[];
}>();
</script>

<template>
  <section class="bg-[#f5f5f7] px-4 py-20 sm:px-8 lg:py-24">
    <div class="mx-auto max-w-[1120px]">
      <h2 class="mb-2 text-[30px] text-[#1d1d1f] sm:text-[40px]" :style="TITRE_SECTION_APPLE">{{ titre }}</h2>
      <p v-if="sousTitre" class="mb-10 text-[17px] font-medium text-[#424245]">{{ sousTitre }}</p>
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" :class="!sousTitre && 'mt-10'">
        <NuxtLink v-for="page in pages" :key="page.href" :to="page.href" class="tuile group flex items-start gap-4 rounded-[22px] bg-white p-6">
          <span class="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-[#f5f5f7] text-[#1d1d1f]">
            <UIcon :name="page.icon" class="size-5" />
          </span>
          <span>
            <span class="mb-1 block text-[17px] text-[#1d1d1f]" :style="TITRE_CARTE_APPLE">{{ page.title }}</span>
            <span class="block text-[14px] leading-[1.45] text-[#6e6e73]">{{ page.description }}</span>
          </span>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<style scoped>
.tuile {
  transition: transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1), box-shadow 0.4s ease;
}
.tuile:hover {
  transform: translateY(-3px);
  box-shadow: 0 24px 50px -30px rgba(0, 0, 0, 0.3);
}
</style>
